/**
 * Created by jiachenpan on 16/11/18.
 */
import { getUrl } from '@/config/url'
export { hasAuth } from '@/utils/auth/index'

export function parseTime (time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime (time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

export function parsePagination (resResult) {
  const pagination = {}
  if (resResult) {
    pagination.pageCount = resResult.totalPage || resResult.pageCount
    pagination.pageSize = resResult.pageSize
    pagination.pageNo = resResult.pageNo
    pagination.totalCount = resResult.total || resResult.count
  }
  return pagination
}
/*
*  localForm：本地需要填充的表單
*  resData： 服務器數據
*  這是一個用於便利填充表單的方法
* */
export function patchValue (localForm, resData) {
  Object.keys(localForm).forEach((key) => {
    if (resData.hasOwnProperty(key)) {
      localForm[key] = resData[key]
    }
  })
}

export function computeStrLen (str) { // 计算字符长度，中文2，英文1
  return str.replace(/[\u0391-\uFFE5]/g, 'aa').length
}

export function mapToOptions (obj) { // 把Map或Object转成下拉选项数组
  if (!obj) {
    return
  }
  if (obj instanceof Map) {
    return [...obj.keys()].map(key => {
      const value = obj.get(key)
      const label = typeof (value) === 'string' ? value : value.label
      return {
        value: key,
        label: label
      }
    })
  }
  if (obj instanceof Object) {
    return Object.keys(obj).map(key => {
      const value = obj[key]
      const label = typeof (value) === 'string' ? value : value.label
      return {
        value: key,
        label: label
      }
    })
  }
}

export function addParamInUrl (url, param) {
  Object.keys(param).forEach((key) => {
    url = url + '&' + key + '=' + param[key]
  })
  return url
}
/*
*  参数urlPrefix：url前缀类型，可参考config/url.js 里面的类型, 如'base'
*      exportUrl: 特定的导出url
*      params: 需要拼接的查询参数对象
* */
export function parseExportLink (urlPrefix, exportUrl, params) {
  const baseUrl = getUrl(urlPrefix)
  let link = `${baseUrl}${exportUrl}`
  Object.keys(params).forEach((key, index) => {
    if (index === 0) {
      link = link + `?${key}=${params[key]}`
    } else {
      link = link + `&${key}=${params[key]}`
    }
  })
  return link
}
